export default {
  player: {
    tooltips: {
      fullscreen: 'Actions are disabled in full screen mode',
    },
  },
  massDelete: 'Delete playlists',
  massEnable: 'Enable playlists',
  massDisable: 'Disable playlists',
};
